import AppointmentLetterForm from "../component/document/AppointmentLetterForm";
import AppraisalLetterForm from "../component/document/AppraisalLetterForm";
import BondAgreementLetterForm from "../component/document/BondAgreementLetterForm";
import ExperienceLetterForm from "../component/document/ExperienceLetterForm";
import ExtensionLetterForm from "../component/document/ExtensionLetterForm";
import NurturAppointmentLetterForm from "../component/document/NurturAppointmentLetterForm";
import NurturSecurityChequeDepositLetterForm from "../component/document/NurturSecurityChequeDepositLetterForm";
import OfferLetterForm from "../component/document/OfferLetterForm";
import RelievingLetterForm from "../component/document/RelievingLetterForm";
import SecurityChequeDepositLetterForm from "../component/document/SecurityChequeDepositLetterForm";
import ConfirmationLetterForm from "../component/document/ConfirmationLetterForm";

export const DocumentFormMap = {
    OFFER_LETTER: OfferLetterForm,
    RELIEVING_LETTER: RelievingLetterForm,
    EXPERIENCE_LETTER: ExperienceLetterForm,
    APPOINTMENT_LETTER: AppointmentLetterForm,
    NURTURE_APPOINTMENT_LETTER: NurturAppointmentLetterForm,
    APPRAISAL_LETTER: AppraisalLetterForm,
    EXTENSION_LETTER: ExtensionLetterForm,
    SECURITY_CHEQUE_DEPOSIT_LETTER: SecurityChequeDepositLetterForm,
    NURTURE_SECURITY_CHEQUE_DEPOSIT_LETTER: NurturSecurityChequeDepositLetterForm,
    EMPLOYMENT_BOND_AGREEMENT_LETTER: BondAgreementLetterForm,
    EMPLOYEE_CONFIRMATION_LETTER: ConfirmationLetterForm
};